import { render, staticRenderFns } from "./CalificacionProveedor.vue?vue&type=template&id=1138367e&scoped=true"
import script from "./CalificacionProveedor.vue?vue&type=script&lang=js"
export * from "./CalificacionProveedor.vue?vue&type=script&lang=js"
import style0 from "./CalificacionProveedor.vue?vue&type=style&index=0&id=1138367e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138367e",
  null
  
)

export default component.exports